import { styled } from '@mui/material/styles';

export const ContainerStyled = styled('div')`
  display: flex;
  justify-content: center;
`;

export const HiddenStyled = styled('div')`
  display: none;
`;
